var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-container"},[_c('guarantee-content',{attrs:{"email":"support@халатенце.рф"}}),_c('div',{staticClass:"b-text-page__guarantee"},[_c('guarantee-list')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }